import { utils, LitElement } from '@hh/global.js'

const { one } = utils || {}

class HHVariantPicker extends HTMLElement {
  constructor() {
    super()
    this.isDragging = false
    this.startX = 0
    this.scrollStartLeft = 0

    this.addEventListener('change', this.onVariantChange)
    this.featureImageSlider = document.querySelector('.js-pdp-featured-images')
    this.variantsInfo = []
    document
      .querySelectorAll('.js-variant-promo-close')
      .forEach((node) =>
        node.addEventListener('click', this.handleVariantPromoClose.bind(this))
      )
  }

  connectedCallback() {
    this.populateVariantInfo()
    this.enableHorizontalDragScrolling()
  }

  enableHorizontalDragScrolling() {
    const optionsContainer = this.querySelector('.vp__options')
    if (!optionsContainer) {
      console.warn('No .vp__options container found.')
      return
    }

    optionsContainer.addEventListener('mousedown', (e) => {
      this.isDragging = true
      this.startX = e.clientX
      this.scrollStartLeft = optionsContainer.scrollLeft
      optionsContainer.style.cursor = 'grabbing'
      optionsContainer.style.userSelect = 'none'
    })

    document.addEventListener('mousemove', (e) => {
      if (!this.isDragging) return

      const deltaX = e.clientX - this.startX
      optionsContainer.scrollLeft = this.scrollStartLeft - deltaX
    })

    document.addEventListener('mouseup', () => {
      if (this.isDragging) {
        this.isDragging = false
        optionsContainer.style.cursor = 'grab'
        optionsContainer.style.userSelect = ''
      }
    })

    optionsContainer.style.cursor = 'grab'
  }

  initDefaultVariant() {
    if (window.location.href.indexOf('variant=') > -1) {
      one('.js-variant-loader').classList.remove('is-loading')

      return
    }
    const defaultVariantInput = this.querySelector(
      '[data-custom-default-variant]'
    )

    if (!defaultVariantInput) {
      one('.js-variant-loader').classList.remove('is-loading')

      return
    }

    if (defaultVariantInput.checked) {
      one('.js-variant-loader').classList.remove('is-loading')

      return
    }

    defaultVariantInput.click()
  }

  onVariantChange() {
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, '', false)
    this.updatePickupAvailability()
    this.updateDescription()
    this.updatePromo()
    window.Klarna?.OnsiteMessaging?.refresh()

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.updateMedia()
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
    }

    one('.js-variant-loader').classList.remove('is-loading')

    this.emitChangeEvent()
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    if (fieldsets && fieldsets.length) {
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find(
          (radio) => radio.checked
        ).value
      })
    } else {
      this.options = Array.from(
        this.querySelectorAll('select'),
        (select) => select.value
      )
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })

    this.currentVariantMetafields = this.getMetafieldVariantData().find(
      (variant) => variant.id === this.currentVariant.id
    )
  }

updateMedia() {
  if (!this.currentVariant) return;

  const galleryContainer = document.querySelector(
    `[data-gallery-container="${this.dataset.section}"]`
  );
  const modelContainer = document.querySelector(
    `[data-model-container="${this.dataset.section}"]`
  );

  if (!galleryContainer && !modelContainer) return;

  const currentVariantInfo = this.variantsInfo.find(
    ({ id }) => id === this.currentVariant.id
  );
  if (!currentVariantInfo) return;

  const htmlDoc = new DOMParser().parseFromString(
    currentVariantInfo.html,
    'text/html'
  );

  const newGallery = htmlDoc.querySelector(
    `[data-gallery-container="${this.dataset.section}"]`
  );
  if (newGallery && galleryContainer) {
    galleryContainer.innerHTML = newGallery.innerHTML;
  }

  const newModel = htmlDoc.querySelector(
    `[data-model-container="${this.dataset.section}"]`
  );
  if (newModel && modelContainer) {
    modelContainer.innerHTML = newModel.innerHTML;
  }

  this.enableHorizontalDragScrolling();
  this.featureImageSlider?.refreshItems();
  this.featureImageSlider?.moveTo(0);
}

  updateURL() {
    if (!this.currentVariant) return;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', this.currentVariant.id);

    window.history.replaceState({}, '', url.toString());
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    )
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (typeof pickUpAvailability.fetchAvailability === "function") {
      if (this.currentVariant?.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id)
      } else {
        pickUpAvailability.removeAttribute("available")
        pickUpAvailability.innerHTML = ""
      }
    } else {
      customElements.whenDefined("pickup-availability").then(() => {
        if (this.currentVariant?.available) {
          pickUpAvailability.fetchAvailability(this.currentVariant.id)
        } else {
          pickUpAvailability.removeAttribute("available")
          pickUpAvailability.innerHTML = ""
        }
      });
    }
  }

  populateVariantInfo() {
    const variants = this.getVariantData() || []

    Promise.all(
      variants.map(async (variant) => {
        const responseText = await fetch(
          `${this.dataset.url}?variant=${variant.id}&section_id=${this.dataset.section}`
        ).then((response) => response.text())

        this.variantsInfo.push({
          id: variant.id,
          html: responseText,
        })

        return true
      })
    ).then(() => {
      this.initDefaultVariant()
    })
  }

  async renderProductInfo() {
    const currentVariantInfo = this.variantsInfo.find(
      ({ id }) => id === this.currentVariant.id
    )

    if (currentVariantInfo) {
      const selector = `${this.dataset.template.includes('rise-gift-cards')
        ? ''
        : '.js-product-form,'
        } .js-price-${this.dataset.section}, hh-product-form`
      const html = new DOMParser().parseFromString(
        currentVariantInfo.html,
        'text/html'
      )

      const destinations = document.querySelectorAll(selector)
      const source = Array.from(html.querySelectorAll(selector))

      destinations.forEach((destination, index) => {
        if (source[index]) {
          destination.outerHTML = source[index].outerHTML
        }
        destination?.classList.remove('visibility-hidden')
      })

      this.toggleAddButton(
        !this.currentVariant.available,
        window.variantStrings.notify
      )

      if (this.currentVariant.available) {
        const cart = await utils.getCart()

        document.dispatchEvent(
          new CustomEvent('cart:changed', {
            bubbles: true,
            detail: {
              cart,
            },
          })
        )
      }
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('hh-button')

    if (!addButton) return

    if (disable) {
      // addButton.setAttribute('disabled', true)
      if (text) {
        addButton.textContent = text
        addButton.text = text
      }
    } else {
      addButton.removeAttribute('disabled')
      let formattedPrice = HH.formatMoney(this.currentVariant.price, window.shopSettings.money_with_currency_format, true)
      let content = `${window.variantStrings.addToCart} - ${formattedPrice}`
      addButton.textContent = content
      addButton.text = content
    }

    if (!modifyClass) return
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')
    if (!addButton) return
    addButton.textContent = window.variantStrings.unavailable
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add('visibility-hidden')
  }

  updateDescription() {
    if (!this.currentVariantMetafields) return
    const productDescriptions = document.querySelectorAll(
      '.js-product-description'
    )
    const variantDescriptions = document.querySelectorAll(
      '.js-variant-description'
    )

    const hasVariantDescription =
      this.currentVariantMetafields.hasVariantDescription

    if (hasVariantDescription) {
      productDescriptions.forEach((productDescription) =>
        productDescription.setAttribute('hidden', '')
      )

      variantDescriptions.forEach((variantDescription) => {
        if (
          parseInt(variantDescription.dataset.variantId) ===
          this.currentVariant.id
        ) {
          variantDescription.removeAttribute('hidden')
        } else {
          variantDescription.setAttribute('hidden', '')
        }
      })
    } else {
      productDescriptions.forEach((productDescription) =>
        productDescription.removeAttribute('hidden')
      )
      variantDescriptions.forEach((variantDescription) =>
        variantDescription.setAttribute('hidden', '')
      )
    }
  }

  updatePromo() {
    if (!this.currentVariantMetafields) return
    const variantPromos = document.querySelectorAll('.js-variant-promo')

    if (this.currentVariantMetafields.hasVariantPromo) {
      variantPromos.forEach((node) => {
        if (parseInt(node.dataset.variantId) === this.currentVariant.id) {
          node.removeAttribute('hidden')
        } else {
          node.setAttribute('hidden', '')
        }
      })
    } else {
      variantPromos.forEach((node) => node.setAttribute('hidden', ''))
    }
  }

  handleVariantPromoClose() {
    document.querySelectorAll('.js-variant-promo').forEach((node) => {
      node.classList.add('hidden')
    })
  }

  emitChangeEvent() {
    window.Klarna?.OnsiteMessaging?.refresh()

    this.dispatchEvent(
      new CustomEvent('variant:change', {
        bubbles: true,
        detail: {
          variant: this.currentVariant,
          metafields: this.currentVariantMetafields,
        },
      })
    )
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('#variants').textContent)
    return this.variantData
  }

  getMetafieldVariantData() {
    this.metafieldVariantData =
      this.metafieldVariantData ||
      JSON.parse(document.querySelector('#variantMetafields').textContent)
    return this.metafieldVariantData
  }
}

customElements.define('hh-variant-picker', HHVariantPicker)